// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconCircleArrowDown = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M32 8C17.191 8 8 17.191 8 32C8 46.809 17.191 56 32 56C46.809 56 56 46.809 56 32C56 17.191 46.809 8 32 8ZM45.9689 35.6962C45.2747 36.3429 33.6661 47.021 33.0225 47.6206C32.379 48.2203 31.6211 48.2203 30.9775 47.6206C30.3339 47.021 18.7253 36.3429 18.0311 35.6961C17.337 35.0494 17.3221 34.2089 17.993 33.538C18.6639 32.8671 19.0135 32.5174 19.6844 31.8466C20.3553 31.1757 21.1958 31.1905 21.8426 31.8846C22.2606 32.3334 26.8972 37.3716 30.1255 40.8801C29.8383 35.0425 29.0184 18.3362 29.0005 17.5518C28.9789 16.6007 29.5662 16 30.5175 16H33.4825C34.4338 16 35.0211 16.6007 34.9995 17.5518C34.9816 18.3362 34.1617 35.0427 33.8746 40.8802C37.1028 37.3717 41.7394 32.3335 42.1575 31.8848C42.8043 31.1906 43.6447 31.1758 44.3156 31.8467C44.9865 32.5175 45.3361 32.8671 46.007 33.538C46.6779 34.2089 46.663 35.0494 45.9689 35.6962Z" />
    </svg>
  );
};
